/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const Seven = (props: any) => (
<svg {...props} xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none">
<path d="M36.8312 17.8425H12.5215L16.1337 0.952637H69.6347L22.7725 70.2695H1.78223L36.8312 17.8425Z" fill="white"/>
<path fillRule="evenodd" clipRule="evenodd" d="M36.8314 17.8424H12.5217L16.134 0.952482H69.6349L22.7728 70.2694H1.78249L36.8314 17.8424ZM35.049 18.7949H11.344L15.3637 0H71.4286L23.2786 71.2218H0L35.049 18.7949Z" fill="#A78952"/>
</svg>);

export default Seven;